import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ItnFundedComment = ({ itnFundedComment, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="itnFundedComment" className="planField">
            <GroupApprovers />
            <TextField
                name="itnFundedComment"
                label={xplanLabels.itnFundedComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("itnFundedComment")}
                value={itnFundedComment ? itnFundedComment : ""}
                onChange={(e) => handleChange("itnFundedComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"itnFundedComment"} />}
        </div>
    );
};

export default ItnFundedComment;
